import { ArrowLeft } from 'lucide-react';

const sections = [
  ['Problem', 'Crop disease detection needs to work in the field, where connectivity is unreliable and lighting changes from one capture to the next.'],
  ['Approach', 'I designed a mobile-first workflow around an efficient vision model, making the prediction loop fast enough to be useful at the point of inspection.'],
  ['Architecture', 'Flutter handles the product experience while TFLite and ONNX provide an on-device inference path that keeps the core workflow independent of a round trip to the cloud.'],
  ['Results', 'The model reached a peak accuracy of 98% in testing, with the product direction focused on practical, low-latency decisions rather than a dashboard full of numbers.'],
  ['What I would improve next', 'I would expand field-captured training data, measure performance across devices, and add clearer confidence guidance for borderline predictions.'],
];

const CaseStudyPage = ({ onNavigate }) => (
  <section className="max-w-4xl">
    <button
      type="button"
      onClick={() => onNavigate('projects')}
      className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-wider text-[#8B8B93] transition-colors hover:text-[#4ADE80]"
    >
      <ArrowLeft size={15} /> Back to projects
    </button>

    <p className="mt-10 font-mono text-xs uppercase tracking-[0.3em] text-[#22C55E]">CASE STUDY / AGRIVIT</p>
    <h1 className="mt-5 text-4xl font-mono font-bold text-[#EDEDEF] sm:text-6xl">AgriViT</h1>
    <p className="mt-6 max-w-3xl text-lg leading-8 text-[#8B8B93]">
      An on-device crop disease detection workflow built for practical decisions in the field.
    </p>

    <div className="mt-10 grid gap-4 sm:grid-cols-3">
      <div className="rounded-xl border border-[#27272A] bg-[#141416] p-5">
        <p className="font-mono text-2xl font-bold text-[#4ADE80]">98%</p>
        <p className="mt-2 text-xs uppercase tracking-wider text-[#8B8B93]">peak accuracy</p>
      </div>
      <div className="rounded-xl border border-[#27272A] bg-[#141416] p-5">
        <p className="font-mono text-2xl font-bold text-[#4ADE80]">ON-DEVICE</p>
        <p className="mt-2 text-xs uppercase tracking-wider text-[#8B8B93]">inference path</p>
      </div>
      <div className="rounded-xl border border-[#27272A] bg-[#141416] p-5">
        <p className="font-mono text-2xl font-bold text-[#4ADE80]">MOBILE</p>
        <p className="mt-2 text-xs uppercase tracking-wider text-[#8B8B93]">delivery surface</p>
      </div>
    </div>

    <div className="mt-14 space-y-10">
      {sections.map(([heading, content], index) => (
        <article key={heading} className="border-t border-[#27272A] pt-6">
          <p className="font-mono text-xs text-[#22C55E]">0{index + 1}</p>
          <h2 className="mt-2 text-2xl font-mono font-bold text-[#EDEDEF]">{heading}</h2>
          <p className="mt-4 max-w-3xl text-base leading-8 text-[#8B8B93]">{content}</p>
        </article>
      ))}
    </div>
  </section>
);

export default CaseStudyPage;
